import {
  SiWhatsapp,
  SiInstagram,
  SiMessenger,
  SiTelegram,
  SiGooglecalendar,
} from '@icons-pack/react-simple-icons';
import type { CatalogEntry, IntegrationId } from './types';

export const INTEGRATION_CATALOG: Record<IntegrationId, CatalogEntry> = {
  'gateway-whatsapp':    { kind: 'simple-icon', icon: SiWhatsapp,        brandColor: '#25D366', label: 'WhatsApp (QR Code)' },
  'whatsapp-business':   { kind: 'simple-icon', icon: SiWhatsapp,        brandColor: '#25D366', label: 'WhatsApp Business API' },
  'instagram-messaging': { kind: 'simple-icon', icon: SiInstagram,       brandColor: '#E4405F', label: 'Instagram Direct' },
  'facebook-messenger':  { kind: 'simple-icon', icon: SiMessenger,       brandColor: '#0084FF', label: 'Facebook Messenger' },
  'telegram-bot':        { kind: 'simple-icon', icon: SiTelegram,        brandColor: '#26A5E4', label: 'Telegram Bot' },
  'email-resend':        { kind: 'feather',     iconName: 'mail',        brandColor: '#8b5cf6', label: 'Email nativo' },
  'email-smtp':          { kind: 'feather',     iconName: 'mail',        brandColor: '#6366f1', label: 'Email SMTP' },
  'website-widget':      { kind: 'feather',     iconName: 'globe',       brandColor: '#8b5cf6', label: 'Widget de Chat' },
  'google-calendar':     { kind: 'simple-icon', icon: SiGooglecalendar,  brandColor: '#4285F4', label: 'Google Calendar' },
  'jetimob':             { kind: 'feather',     iconName: 'database',    brandColor: '#0EA5E9', label: 'Jetimob' },
  'dwv':                 { kind: 'feather',     iconName: 'database',    brandColor: '#22C55E', label: 'DWV' },
  'kenlo':               { kind: 'feather',     iconName: 'database',    brandColor: '#F97316', label: 'Kenlo' },
  'payment-asaas':       { kind: 'feather',     iconName: 'credit-card', brandColor: '#1A56DB', label: 'Asaas' },
};
